<template>
    <div>
        <!-- <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in list" :data-id="item.id" :key="index"
                    @click="toCaseDetail(item.id)">
                    <div style="height:250px;">
                        <img :src="item.litpic" alt="" class="swiper-slide-img">
                        <p class="text-gray font-14 swiper-slide-p">{{ item.title }}</p>
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev swiper-button-white" style="top: 40%;"></div>
            <div class="swiper-button-next swiper-button-white" style="top: 40%;"></div>
     
        </div> -->
        <div class="swiper">
            <el-carousel :interval="5000" type="always" height="380px" indicator-position="none">
                <el-carousel-item class="swiper-slide" v-for="(item, index) in list" :data-id="item.id" :key="index">
                    <div style="height:300px;" @click="toCaseDetail(item.id)">
                        <img :src="item.litpic" alt="" class="swiper-slide-img">
                        <p class="text-gray font-14 swiper-slide-p">{{ item.title }}</p>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import { getCaselist } from '../../api/api'
export default {
    name: '',
    data() {
        return {
            list: []
        }
    },
    methods: {
        getData() {
            //console.log(this.$route.query.pid);
            let pid = -1;
            switch (this.$route.query.pid) {
                //中文门窗
                case '74':
                    pid = 88;
                    break;
                //中文幕墙
                case '76':
                    pid = 90;
                    break;
                //中文精装
                case '78':
                    pid = 92;
                    break;
                default:
                    pid = this.$route.query.pid;
                    break;
            }
            //console.log(pid) 
            let data = {
                typeid: pid || -1
            }
            getCaselist(data).then(res => {
                if (res.code == 1) {
                    this.list = res.data

                    this.$nextTick(() => {
                        var swiper = new Swiper('.swiper-container', {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            autoplay: true,
                            loop: true,
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },

                        });

                        // $('.swiper-slide').click(function () {
                        //     window.open(window.location.origin + window.location.pathname + '#/CaseDetail?id=' + $(this).data('id'), "_blank");
                        // })
                    })
                }
            })
        },
        toCaseDetail(id) {
            window.open(window.location.origin + window.location.pathname + '#/CaseDetail?id=' + id, "_blank");
        },
    },
    mounted() {
        this.getData()

    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    width: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    cursor: pointer;
    // background: #CDB499;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.swiper-slide-img {
    height: 280px;
}

.swiper-slide-p {

    margin-top: 10px;
    text-align: left;
}
</style>